import script from "./otp.vue?vue&type=script&setup=true&lang=js"
export * from "./otp.vue?vue&type=script&setup=true&lang=js"

import "./otp.vue?vue&type=style&index=0&id=9f5e8778&scoped=true&lang=scss"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f5e8778"]])

export default __exports__